import { ShortCodeType } from './../../../shared/Enums/ShortCodeType';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import ShortService from '../ShortService';
import WithRender from './AddShortCode.html';
import UserService from '../../../shared/userService/UserService';
import { Toaster } from '../../../Services/toast';
import ValidationService from '../../../Services/ValidationService';
import { ShortModel } from '../ShortModel';
import OperatorService from '@/Services/OperatorService';
import ProviderService from '@/components/Provider/ProviderService';
import VirtualOperatorRules from '@/shared/VirtualOperatorRules';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        ShortService,
        UserService,
        OperatorService,
        ProviderService,
    ],
})
export default class AddShortCode extends Vue {
    public get isValid(): boolean {
        const m = this.shortCodeModel || {};

        const hasOperator =
            m.operatorId !== null &&
            m.operatorId !== undefined &&
            m.operatorId !== 0;

        const hasType =
            m.shortCodeType !== null &&
            m.shortCodeType !== undefined &&
            m.shortCodeType !== 0;

        const hasName =
            typeof m.name === 'string' &&
            m.name.trim().length > 0;

        return hasOperator && hasType && hasName;
    }
    @Inject(ShortService) public shortService!: ShortService;
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(UserService) public userService!: UserService;
    @Inject(OperatorService) public operatorService!: OperatorService;
    @Inject(ProviderService) public providerService!: ProviderService;

    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;
    @Prop({ type: String, default: '' })
    public id: string | any;
    public addShortDiDialog: boolean = false;
    public User: any;
    public operatorOptions: any[] = [];
    public shortCodeTypes: any;
    public shortCodeModel: ShortModel | any = {};
    public editMode: boolean = false;
    public virtualOperatorLocked: boolean = false;



    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        this.User = await this.userService.getUser();
        this.id = this.$route.params.id;
        if (this.id && this.id !== null) {
            const responseShortCode = await this.shortService.getById(this.id);
            this.shortCodeModel = responseShortCode.result;
            this.editMode = true;
        }
    }
    public async created() {
        const response = await this.operatorService.getAll();
        if (response.isSuccess) {
            this.operatorOptions = response.result;
         }
        this.shortCodeTypes =
                [
                    { id: 1, name: 'White List' },
                    { id: 2, name: 'Black List' },
                ];

        const routeId = this.$route.params.id;
        if (!routeId) {
            this.User = await this.userService.getUser();
            if (this.User && this.User.details && this.User.details.ProviderId) {
                const provider = await this.providerService.GetById(this.User.details.ProviderId);
                this.applyVirtualOperatorOperatorLock(provider);
            }
        }
    }

    public isShortCodeNumberField(val: KeyboardEvent) {
        if (!this.validationService.isNumber(val.key)) {
            val.preventDefault();
            Toaster.error(this.$t('shortPage.shortCodeNumbersOnly').toString());
        }
    }

    public isShortCodeNumberFieldPaste(ev: any) {
        const paste = (ev.clipboardData).getData('text');
        if (!this.validationService.isNumeric(paste)) {
            ev.preventDefault();
            Toaster.error(this.$t('shortPage.shortCodeNumbersOnly').toString());
        }
    }
    public showaddShortCodeDialog(id: string) {
        this.addShortDiDialog = true;
    }
    public hideddShortDiDialog() {
        this.addShortDiDialog = false;
    }
    public async addShortCode() {
        const response = await this.shortService.post(this.shortCodeModel.name, this.shortCodeModel.operatorId,
            this.User.details.ProviderId, this.shortCodeModel.shortCodeType);
        if (response.isSuccess && response.result) {
            Toaster.success(this.$t('shared.addShortSuccessfully').toString());
            this.shortCodeModel.operatorId = 0;
            this.shortCodeModel.name = '';
            this.$router.push({ name: 'Shorts' });
        } else {
            Toaster.error(response.errorMessage);
        }
        this.hideddShortDiDialog();
    }

    public async editShortCode() {
        const response = await this.shortService.edit(this.id, this.shortCodeModel.shortCodeType);
        if (response.isSuccess && response.result) {
            Toaster.success(this.$t('shared.updateShortSuccessfully').toString());
            this.$router.push({ name: 'Shorts' });
        } else {
            Toaster.error(response.errorMessage);
        }
        this.hideddShortDiDialog();
    }

    public save() {
        this.editMode ? this.editShortCode() : this.addShortCode();
    }

    private applyVirtualOperatorOperatorLock(provider: any) {
        const result = VirtualOperatorRules.filterOperatorOptionsById(provider, this.operatorOptions);
        this.operatorOptions = result.options;
        this.virtualOperatorLocked = result.locked;
        if (result.operatorId !== null) {
            this.shortCodeModel.operatorId = result.operatorId;
        }
    }
}
